import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03c7f685"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "video-container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No valid video URL provided.", -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_ctx.videoUrl)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("iframe", {
          width: "100%",
          height: "400px",
          src: _ctx.videoUrl,
          title: "YouTube video player",
          frameborder: "0",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: ""
        }, null, 8, _hoisted_2)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
}